module.exports = __webpack_public_path__ + "img/img6.e5a7a650.png";